import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable, throwError, pipe } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { GenericService } from '@app/core/services/generic.service';
import { AuthenticationService } from '../../core/services/authentication.service';

import { Segurado, Loading, Documento } from '@app/shared/models';

@Injectable({
  providedIn: 'root'
})
export class SeguradoService extends GenericService<any> {

  constructor(http: HttpClient, private auth: AuthenticationService) {
    super('censo/autoAtendimento', http);
  };

  get idAutoAtendimento(): number {
    return this.auth.currentUserValue.idAutoAtendimento;
  }

  get apiBase(): string {
    return `${this.api}/${this.idAutoAtendimento}`;
  }

  getSegurado(loading?: Loading): Observable<Segurado> {
    this.startLoading(loading);
    return this.getHttpClient().get<Segurado[]>(`${this.apiBase}/segurado`)
      .pipe(this.configMapAndLoading(loading), this.result());
  }

  putSegurado(value: Segurado, loading?: Loading): Observable<Segurado> {
    this.startLoading(loading);
    return this.getHttpClient().put(`${this.apiBase}/segurado/${value.id}`, value)
      .pipe(this.configMapAndLoading(loading), this.result());
  }

  buscarTipoSegurado(loading?: Loading): Observable<any> {
    this.startLoading(loading);
    return this.getHttpClient().get<Segurado[]>(`${this.apiBase}/segurado/tipo`)
      .pipe(this.configMapAndLoading(loading), this.result());
  }

  buscarDocumentosSegurado(loading?: Loading): Observable<any> {
    this.startLoading(loading);
    return this.getHttpClient().get<Documento[]>(`${this.apiBase}/documentos`)
      .pipe(this.configMapAndLoading(loading), this.result());
  }

  enviarCodigoCelular(idSegurado: number, celular: any, loading?: Loading): Observable<any> {
    this.startLoading(loading);
    return this.getHttpClient().post(`${this.apiBase}/segurado/${idSegurado}/contato/enviar`, celular)
      .pipe(this.configMapAndLoading(loading));
  }

  validarCodigoCelular(idSegurado: number, codigo: any, loading?: Loading): Observable<any> {
    this.startLoading(loading);
    return this.getHttpClient().post(`${this.apiBase}/segurado/${idSegurado}/contato/validar`, codigo)
      .pipe(this.configMapAndLoading(loading));
  }

  result(): any {
    return pipe(
      map((res: any) => res),
      catchError((err: any) => throwError({ message: err })));
  }
}
